import React, { useContext, useEffect, useState } from 'react';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import { WelletContext } from '../../../context/WelletContext';
import { getQueryString } from '../../../helpers/url';
import { useDispatch, useSelector } from 'react-redux';
import {
  addExtraProduct,
  removeExtraProduct,
  setExtraProductList,
} from '../../../actions/extraProductActions';
import { useTranslation } from 'react-i18next';

import ButtonReservation from '../../../components/Common/Button/ButtonReservation';
import Money from '../../../components/Common/Money/Money';
import { setReservation } from '../../../actions/reservationActions';
import ChevronIcon from '../../../components/icons/chevronIcon';
import styles from '../ReservationCheck/reservationCheck.module.css';
import { CircleSpinner } from 'react-spinners-kit';
import EventHeader from '../../../components/Common/EventHeader/EventHeader';
import { format } from 'date-fns';
import ProductModal from '../../../components/Common/ProductModal/ProductModal';
import ReservationTicketInfo from '../ReservationTicketInfo/ReservationTicketInfo';
import { fetchProducts } from '../../../services/product/productService';
import EventProductCard from '../../../components/EventProductCard/EventProductCard';
import SkeletonReservationArea from '../../../components/Skeletons/SkeletonReservationArea';
import ProductCard from '../../../components/ProductCard/ProductCard';
import SeatMap from '../../../components/SeatMap/SeatMap';
import { getDatesWithEvents, fetchEventDetails } from '../../../services/EventsServices';
import {
  formatDateTime,
  formatDatSemiShort,
  getDateFromOffset,
  getLocale,
} from '../../../helpers/dates';
import DatePickerSlider from '../../../components/DatePickerSlider/DatePickerSlider';
import TimePickerSlider from '../../../components/TimePickerSlider/TimePickerSlider';
import EmptyActivity from '../../../components/Common/EmptyActivity/EmptyActivity';

const CalendarTicketSelector = ({ history }) => {
  const { t } = useTranslation();
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);

  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);

  const [error, setError] = useState(null);
  const [products, setProducts] = useState([]);
  const [groupProducts, setGroupProducts] = useState([]);
  const extraProducts = useSelector((state) => state.extraProducts.items);

  const [loading, setLoading] = useState(true);
  const [loadingImage, setLoadingImage] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(true);

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventDetail, setEventDetail] = useState(null);
  const [loadingEventDetail, setLoadingEventDetail] = useState(true);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const idReservation = getQueryString('id');
  const showId = getQueryString('showId');
  const productCategoryId = getQueryString('productCategoryId');
  const [selectedProductCategory, setSelectedProductCategory] = useState(null);
  const orderType = ['ADULTS', 'ADOLESCENTS', 'CHILDREN', 'INFANTS', 'SENIORS', 'ALL'];
  const currencyPrice = useSelector((state) => state.currency?.selected?.name);
  const [datesWithEvents, setDatesWithEvents] = useState([]);
  const [show, setShow] = useState(null);
  const [today, setToday] = useState(null);
  const [todayDate, setTodayDate] = useState(null);
  const [dates, setDates] = useState([]);
  const [datesCalendar, setDatesCalendar] = useState([]);
  const [listTimes, setListTimes] = useState([]);
  const [eventId, setEventId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [emptyEvents, setEmptyEvents] = useState(false);

  const queryParams = new URLSearchParams({
    showId: showId,
  });

  if (idReservation !== null && idReservation !== undefined) {
    queryParams.append('id', idReservation);
  }

  let query = `?${queryParams.toString()}`;

  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: showId,
          lang: language,
          details: false,
          reservationType: 'RESTAURANT',
          images: true,
          videos: false,
          IsFeature: true,
        },
      });

      setShow(result.data);
      const date = format(new Date(getDateFromOffset(result.data.utcOffset)), 'yyyy-MM-dd');
      setTodayDate(new Date(getDateFromOffset(result.data.utcOffset)));
      setToday(date);
      setSelectedDate(date);
      fetchEvents(date);
      fetchCalendarEvents(date);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchEvents = async (date) => {
    try {
      const newEvents = await getDatesWithEvents(showId, date, language, 10, welletContext);
      setDates(
        newEvents.map((event) => {
          return {
            date: new Date(formatDateTime(event.date)),
            hasEvents: event.eventTimes.length > 0,
          };
        }),
      );
      // setDates(newEvents.map((event) => {date: new Date(formatDateTime(event.date)), hasEvents: event.eventTimes.length > 0 }));
      setTimes(newEvents[0].eventTimes);
      setDatesWithEvents(newEvents);

      if (newEvents[0].eventTimes.length === 0) {
        setEmptyEvents(true);
        setLoading(false);
        setLoadingEventDetail(false);
        return;
      }

      const event = newEvents[0].eventTimes[0].events[0];
      setSelectedEvent(event);
      setSelectedEvent(setSelectedEvent);
      setEventId(event.eventId);
      getEventDetails(event.eventId);
      getProducts(event.startDate, event.eventId);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCalendarEvents = async (date) => {
    try {
      const newEvents = await getDatesWithEvents(showId, date, language, 365, welletContext);
      setDatesCalendar(
        newEvents.map((event) => {
          return {
            date: new Date(formatDateTime(event.date)),
            hasEvents: event.eventTimes.length > 0,
          };
        }),
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const setTimes = async (times) => {
    setListTimes(times.map((t) => t.time));
  };

  const productCategorySetup = () => {
    if (!eventDetail) return;
    let newSelectedProductCategory = eventDetail.productCategories.find(
      (c) => c.id.toString() === productCategoryId,
    );
    if (!newSelectedProductCategory) {
      newSelectedProductCategory = eventDetail.productCategories[0];
    }
    setSelectedProductCategory(newSelectedProductCategory);
  };

  const getEventDetails = async (id) => {
    setLoadingEventDetail(true);
    setLoadingProducts(true);
    setGroupProducts([]);
    try {
      const response = await fetchEventDetails(welletContext, id, language);
      setEventDetail(response);
    } catch (error) {
      console.error(error);
    }
    setLoadingEventDetail(false);
  };

  const getProducts = async (date, eventId, productCategoryId) => {
    setLoadingProducts(true);
    setError(null);

    try {
      const result = await fetchProducts(
        welletContext,
        showId,
        date,
        language,
        eventId,
        productCategoryId,
      );

      if(result.data.products.length > 0 ){
        setEmptyEvents(false);
      }

      if (result && result.data) {
        let initializedProducts = result.data.products.map((product) => ({
          ...product,
          quantity: 0,
          disabled: false,
        }));

        const groupByType = initializedProducts.reduce((acc, item) => {
          const key = item.ageRange ? item.ageRange.name : 'ALL';
          if (!acc[key]) {
            acc[key] = {
              ageRangeId: item.ageRange?.name,
              ageRangeLabel: item.ageRange?.nameString,
              items: [],
            };
          }
          acc[key].items.push(item);
          return acc;
        }, {});

        setProducts(initializedProducts);
        setGroupProducts(groupByType);

        dispatch(setExtraProductList(result.data.extraProducts));

        if (initializedProducts.length === 0) setError(t('productsNotAvailables'));
      }
    } catch (error) {
      setError(
        error.response && error.response.data ? t('reservationNotAvailables') : t('callApiError'),
      );
      console.error(error);
    } finally {
      setLoadingProducts(false);
    }
  };

  const handleSelectDate = (date) => {
    setSelectedDate(date);
    setEmptyEvents(false);
    setProducts([]);

    if (!datesWithEvents.find((e) => e.date === date)) {
      fetchEvents(date);
      setTodayDate(new Date(date));
      return;
    }

    setTimes(datesWithEvents.find((e) => e.date === date).eventTimes);
    const event = datesWithEvents.find((e) => e.date === date).eventTimes[0].events[0];
    setSelectedEvent(event);
    setEventId(event.eventId);
    getEventDetails(event.eventId);
    getProducts(event.startDate, event.eventId);
  };

  const handleSelectTime = (time) => {
    setProducts([]);

    const event = datesWithEvents
      .find((e) => e.date === selectedDate)
      .eventTimes.find((e) => e.time === time).events[0];

    setSelectedEvent(event);
    setEventId(event.eventId);
    getProducts(event.startDate, event.eventId);
  };

  const handleIncrement = (id) => {
    const index = products.findIndex((p) => p.id === id);
    const product = products[index];

    if (product.stock && product.stock === product.quantity) return;

    let newProducts = [...products];

    if (product.isExclusive) {
      newProducts
        .filter((p) => p.id !== product.id)
        .forEach((p) => {
          p.disabled = true;
          p.quantity = 0;
          dispatch(removeExtraProduct({ ...p, quantity: 0, specialType: 'EXTRAPAX' }));
        });
    }

    newProducts[index].disabled = false;
    newProducts[index].quantity = newProducts[index].stock
      ? Math.min(newProducts[index].stock, newProducts[index].quantity + 1)
      : newProducts[index].quantity + 1;

    setProducts(newProducts);

    if (product.extraPax > 0) {
      dispatch(addExtraProduct({ ...product, quantity: 0, specialType: 'EXTRAPAX' }));
    }

    if (product.behavior === 'NO_GUARANTEED') {
      const reservationInfo = setReservationInfo();
      dispatch(setReservation(reservationInfo));
      history.push({
        pathname: '/reservation-no-guaranteed',
        search: query,
      });
    }

    // uncomment the following block to disable multi product selection
    // if (product.reservationType === 'AREA') {
    //   const reservationInfo = setReservationInfo();
    //   dispatch(setReservation(reservationInfo));

    //   if (product.behavior === 'NO_GUARANTEED')
    //     history.push({
    //       pathname: '/reservation-no-guaranteed',
    //       search: query,
    //     });
    //   else if (product.extraPax > 0 || extraProducts.length > 0) {
    //     linkToExtraProducts();
    //   } else {
    //     handleContinue();
    //   }
    // }
  };

  const handleDecrement = (id) => {
    const index = products.findIndex((p) => p.id === id);
    let newProducts = [...products];

    newProducts[index].quantity = Math.max(0, newProducts[index].quantity - 1);

    if (newProducts[index].isExclusive && newProducts[index].quantity === 0) {
      newProducts.forEach((p) => (p.disabled = false));
    }
    dispatch(removeExtraProduct({ ...newProducts[index], quantity: 0, specialType: 'EXTRAPAX' }));
    setProducts(newProducts);
  };

  const handleCategoryClick = (type) => {
    setSelectedProductCategory(type);
    getProducts(selectedEvent.startDate, eventId, type.id);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const onInfoClick = (id) => {
    setSelectedProduct(id);
    toggleModal();
  };

  const handleContinue = () => {
    query += `&eventId=${eventId}`;
    const reservationInfo = setReservationInfo();
    dispatch(setReservation(reservationInfo));

    if (extraProducts.length > 0) {
      linkToExtraProducts();
    } else if (eventDetail.hasTransportation) {
      history.push({
        pathname: '/pickup',
        search: query,
      });
    } else {
      history.push({
        pathname: '/reservation-check-tickets',
        search: query,
      });
    }
  };

  const linkToExtraProducts = () => {
    history.push({
      pathname: '/area-extra-reservation',
      search: query,
    });
  };

  const setReservationInfo = () => {
    let finalProducts = [];

    products
      .filter((product) => product.quantity > 0)
      .map((product) => {
        finalProducts.push({
          id: product.id,
          quantity: product.quantity,
          extraPaxs: 0,
          specialType: product.specialType,
          paxs: product.pax * product.quantity,
        });
      });

    const reservationInfo = {
      showId: showId,
      showName: eventDetail.name,
      products: finalProducts,
      date: selectedDate,
      hasTransportation: eventDetail.hasTransportation,
      performance: format(new Date(selectedEvent.startDate), 'HH:mm'),
      paxs: finalProducts.reduce((sum, item) => sum + item.paxs, 0),
    };

    return reservationInfo;
  };

  const sumTotal = () => {
    return products
      .filter((p) => p.quantity > 0)
      .reduce((total, p) => total + p.prices.price * p.quantity, 0);
  };

  const totalConsume = () => {
    return products
      .filter((p) => p.quantity > 0)
      .reduce((total, p) => total + p.prices.consumption * p.quantity, 0);
  };

  const totalPax = () => {
    return products
      .filter((p) => p.quantity > 0)
      .reduce((total, p) => total + p.pax * p.quantity, 0);
  };

  const renderTimes = () => {
    return (
      <>
        {listTimes.length > 1 && (
          <div className='mt-2'>
            <TimePickerSlider times={listTimes} handleSelect={(e) => handleSelectTime(e)} />
          </div>
        )}
        <div className='font-small fw-600 mt-3'>
          <div className='row'>
            <div className='col'>{formatDatSemiShort(selectedEvent?.startDate, locale)}</div>
            <div className='col text-right'>
              {t('fromTimeToTime', {
                time: format(new Date(selectedEvent?.startDate), 'HH:mm aaa'),
                time2: format(new Date(selectedEvent?.endDate), 'HH:mm aaa'),
              })}
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderProductCategories = () => {
    if (eventDetail.productCategories.length <= 1) return;

    return (
      <div className='row text-center font-normal2 mt-4 px-3'>
        {eventDetail.productCategories.map((category) => (
          <div
            key={category.id}
            onClick={() => handleCategoryClick(category)}
            className={`col p-2 ${
              selectedProductCategory?.id === category.id ? 'bold' : 'text-tertiary'
            }`}
            style={{
              borderBottom:
                selectedProductCategory?.id === category.id
                  ? '4px solid var(--color-primary)'
                  : '1px solid #7E7E7E',
            }}
          >
            {category.name}
          </div>
        ))}
      </div>
    );
  };

  const renderProducts = () => {
    if (loadingProducts) {
      return SkeletonReservationArea();
    }

    // if (selectedProductCategory.seatMap) {
    //   return (
    //     <SeatMap
    //       seatMapConfig={selectedProductCategory.seatMap}
    //       products={products}
    //       eventDetail={eventDetail}
    //       showId={showId}
    //       eventId={eventId}
    //     />
    //   );
    // }

    return (
      <div className='product-list mt-3'>
        {orderType.map((type, i) => {
          const productItems = groupProducts[type];
          if (productItems) {
            return (
              <div className='product-types' key={i}>
                {type !== 'ALL' && (
                  <div className='fw-600 text-primary font-tiny pl-1'>
                    {productItems.ageRangeLabel}
                  </div>
                )}
                <div className='mt-2'>
                  {productItems.items.map((p) => (
                    <div className='mt-2' key={p.id}>
                      {p.behavior === 'NO_GUARANTEED' ? (
                        <EventProductCard
                          product={p}
                          handleIncrement={() => handleIncrement(p.id)}
                          handleDecrement={() => handleDecrement(p.id)}
                          hasMoreInfo={false}
                        />
                      ) : p.reservationType === 'AREA' ? (
                        <ProductCard
                          product={p}
                          handleIncrement={() => handleIncrement(p.id)}
                          handleDecrement={() => handleDecrement(p.id)}
                          hasMoreInfo={true}
                          onInfoClick={() => {
                            onInfoClick(p);
                          }}
                          loadingImage={loadingImage}
                          setLoadingImage={setLoadingImage}
                        />
                      ) : (
                        <ProductCard
                          product={p}
                          handleIncrement={() => handleIncrement(p.id)}
                          handleDecrement={() => handleDecrement(p.id)}
                          hasMoreInfo={true}
                          onInfoClick={() => {
                            onInfoClick(p);
                          }}
                          loadingImage={loadingImage}
                          setLoadingImage={setLoadingImage}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  };

  const hasItems = products?.some((p) => p.quantity > 0);
  const reservationType = hasItems ? products[0].reservationType : null;

  useEffect(() => {
    productCategorySetup();
  }, [eventDetail]);

  useEffect(() => {
    getShow();
  }, []);

  return (
    <>
      {loading ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        <>
          <Header />
          <ContentApp>
            <EventHeader
              eventImg={show.bannerImageUrl}
              eventName={show.name}
              eventDescription={show.city.name}
              size='small'
            />

            <div className='mt-3'>
              <DatePickerSlider
                dates={dates}
                firstDate={todayDate}
                handleSelect={(e) => handleSelectDate(e)}
                datesCalendar={datesCalendar}
              />
            </div>
            {loadingEventDetail ? (
              <div className='loaderDiv'>
                <CircleSpinner
                  className='spinner-app mx-auto'
                  style={{ margin: 'auto' }}
                  size={40}
                  color='var(--color-font-primary)'
                />
              </div>
            ) : (
              <>
                {emptyEvents ? (
                  <div className='mt-3'>
                    <EmptyActivity title={t('noResults')} />
                  </div>
                ) : (
                  <>
                    {renderTimes()}
                    {renderProductCategories()}
                    <div className='mt-3' style={{ paddingBottom: '115px' }}>
                      <>
                        {renderProducts()}
                        <div className='mt-4 fw-semibold font-tiny text-secondary'>
                          {t('priceIn', { currency: currencyPrice })}
                        </div>
                      </>
                    </div>
                  </>
                )}

                {hasItems && (
                  <div
                    className='position-fixed w-100'
                    style={{
                      bottom: 0,
                      left: 0,
                      zIndex: 2,
                    }}
                  >
                    <div className='container'>
                      <div className='row justify-content-center'>
                        <div className='col-12 col-md-7 col-lg-6 p-0'>
                          <ButtonReservation
                            leftContent={
                              <>
                                <div className='font-normal'>
                                  {t('total')} <Money value={sumTotal()} />
                                </div>
                                <div className='font-smaller'>
                                  {reservationType.toUpperCase() === 'AREA'
                                    ? t('upToGuests', { pax: totalPax() })
                                    : t('person', { count: totalPax() })}
                                </div>
                                {totalConsume() > 0 && (
                                  <div className='font-smaller'>
                                    {t('consumptionCredit')} <Money value={totalConsume()} />
                                  </div>
                                )}
                              </>
                            }
                            rightContent={
                              <div>
                                {t('continue')}
                                <span>
                                  <ChevronIcon size={20} fillColor={'#000'} />
                                </span>
                              </div>
                            }
                            size='large'
                            className={`${styles.btn}`}
                            onClick={handleContinue}
                            fixed={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </ContentApp>
        </>
      )}
      <ProductModal
        open={isModalOpen}
        onClose={toggleModal}
        animationClass='slide-left-right'
        fullScreen={true}
        hasBackground={true}
        backIcon={true}
      >
        <ReservationTicketInfo
          productId={selectedProduct?.id}
          showAddButton={
            selectedProduct?.stock === null ||
            (!selectedProduct?.hasSoldOut && selectedProduct?.stock > 0)
          }
          handleIncrement={handleIncrement}
          prices={selectedProduct?.prices}
          toggleModal={toggleModal}
          isModalOpen={isModalOpen}
        />
      </ProductModal>
    </>
  );
};

export default CalendarTicketSelector;
